import React, { useEffect, useRef, useState } from "react";
import { useInView, animate } from "framer-motion";

export default function CountUp({ to, suffix = "", duration = 1.8, className = "" }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true, amount: "some" });
  const [val, setVal] = useState(0);
  const [started, setStarted] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      const r = ref.current?.getBoundingClientRect();
      if (r && r.top < window.innerHeight && r.bottom > 0) setStarted(true);
    }, 400);
    return () => clearTimeout(id);
  }, []);

  useEffect(() => {
    if (!(inView || started)) return;
    const controls = animate(0, to, {
      duration,
      ease: [0.16, 1, 0.3, 1],
      onUpdate: (v) => setVal(Math.round(v)),
    });
    return () => controls.stop();
  }, [inView, started, to, duration]);

  return (
    <span ref={ref} className={className}>
      {val.toLocaleString()}{suffix}
    </span>
  );
}
